// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE';
export const OTP_RESPONSE = 'OTP_RESPONSE';
export const OTP_VERIFYRESPONSE = 'OTP_VERIFYRESPONSE';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
